import React, { Fragment } from 'react';
import _ from 'lodash';
import Page from './Page';
import ShortForm from './ShortForm';
import Select from './Select';
import TextField from 'material-ui/TextField';
import Chip from 'material-ui/Chip';
import Button from 'material-ui/Button';
import ArrowUp from 'material-ui-icons/ArrowUpward';
import ArrowDown from 'material-ui-icons/ArrowDownward';
import SearchIcon from 'material-ui-icons/Search';
import ExperimentListItem from './ExperimentListItem';

const SORT_COLUMN_OPTIONS = [
	{ value:"name",      label: "Name"},
	{ value:"start",     label: "Start Date"},
	{ value:"status",    label: "Status"},
	{ value:"participants", label: "Participants"},
	{ value:"time",      label: "Estimated Time"},
	{ value:"incentive", label: "Reward"},
];


export default class ManageExperiments extends Page {

	static get mustBeResearcher(){ return true; }

	constructor(...args){
		super(...args);
		this.app.manageExperimentsForm.loading = true;
	}

	componentDidMount(){
		this.app.manageExperimentsForm.load();
	}


	render(){

		let originalRows = this.app.manageExperimentsForm.rows || [];
		let rows = this.app.manageExperimentsForm.rows || [];
		rows = this.app.fuzzyMatch(rows, this.app.manageExperimentsForm.search, row => row.name )
		if(this.app.manageExperimentsForm.statusFilter){
			rows = rows.filter( row => row.status === this.app.manageExperimentsForm.statusFilter );
		}else{
			rows = rows.filter( row => row.status !== 'archived' )
		}
		rows = _.sortBy(rows, this.app.manageExperimentsForm.sortColumn || 'name')
		if(!this.app.manageExperimentsForm.sortAscending){
			rows.reverse();
		}

		let balance = _.sum(this.app.manageExperimentsForm.rows.map(row=> row.totalCharges)) * -1;

		return (
			<Fragment>
				<div style={{textAlign:'right'}}>

					{!this.app.manageExperimentsForm.loading && 
					<div style={{display:'inline-block', fontSize:'13px', marginRight:'15px'}}>
						Balance:  {balance >=0 ? `$${balance}` : <span style={{color:'var(--red)'}}>-${Math.abs(balance)}</span> }
					</div>
					}

					<Button className='create-experiment-button' style={{width:'200px'}} variant="raised" color="primary" onClick={ () => { this.app.createExperiment();  } }>Create Experiment</Button>
				</div>
				<ShortForm 
					label="My Experiments"
					formWidth="medium"
					waiting={this.app.manageExperimentsForm.loading}
				>

					<div className='Experiments-filters'>
						<StatusChip label="ALL" value="" app={this.app} />
						<StatusChip label="ACTIVE" value="active" app={this.app} />
						<StatusChip label="INACTIVE" value="inactive" app={this.app} />
						<StatusChip label="ARCHIVE" value="archived" app={this.app} />
						
						<TextField
							label={<SearchIcon />}
							id="search"
							value={window.app.manageExperimentsForm.search || ''}
							onChange={ e => {window.app.manageExperimentsForm.search = e.currentTarget.value; window.app.forceUpdate()} }
							margin="normal"
							style={{width:'120px', marginLeft:'7px'}}
							/>
						&nbsp;&nbsp;
						<Select
							label="Sort by"
							id="sortColumn"
							value={window.app.manageExperimentsForm.sortColumn}
							onChange={ o =>{ window.app.manageExperimentsForm.sortColumn = o.value; window.app.forceUpdate(); } }
							options={SORT_COLUMN_OPTIONS}
							/>

						<div 
							onClick={  o =>{ window.app.manageExperimentsForm.sortAscending = !window.app.manageExperimentsForm.sortAscending; window.app.forceUpdate(); } }
							style={{display:'inline-block', position: 'relative',top: '7px', paddingLeft: '7px'}}>
							{ !!window.app.manageExperimentsForm.sortAscending ? <ArrowUp /> : <ArrowDown /> }
						</div>
					</div>
					

					{rows.map( (row, i) => (
						<ExperimentListItem row={row} key={i} pariticpantMode={false} />
					))}
					
					{ originalRows.length === 0 && <div>You have not yet created an experiment.</div> }

					{ originalRows.length !== 0 && rows.length === 0 && <div>There are no matching experiments.</div> }

				</ShortForm>
			</Fragment>
		);
	}
}

const StatusChip = ({app, label, value }) => (
	<Chip
		style={{margin:'0px 5px'}}
		id={`status-chip-${value}`}
		label={label}
		onClick={ e => {app.manageExperimentsForm.statusFilter = value; app.forceUpdate()} }
		className={app.manageExperimentsForm.statusFilter === value ? 'selected-chip' : undefined}
		/>
);


// WEBPACK FOOTER //
// ./src/components/ManageExperiments.js